export const CLARITY_EVENTS = {
    PAGE_VIEW: "page_view",

    // Auth
    LOGIN_CLICKED: "login_clicked",
    OTP_VERIFICATION_CLICKED: "otp_verification_clicked",
    OTP_RESEND_CLICKED: "otp_resend_clicked",
    SIGNUP_CLICKED: "signup_clicked",

    // Purchase / Checkout
    CHECKOUT_STARTED: "checkout_started",
    PAYMENT_SUCCESS: "payment_success",
    PAYMENT_FAILED: "payment_failed",

    // User actions
    BUTTON_CLICK: "button_click",
    FORM_SUBMIT: "form_submit",

    // Dashboard
    DASHBOARD_LOADED: "dashboard_loaded",

    // Sidebar
    SIDEBAR_ITEM_CLICKED: "sidebar_item_clicked",
    SIDEBAR_EXPANDED: "sidebar_expanded",
    SIDEBAR_COLLAPSED: "sidebar_collapsed",

    // Album actions
    ALBUM_CREATED: "album_created",
    ALBUM_EDITED: "album_edited",
    ALBUM_CODE_SHARED: "album_code_shared",

    // Image actions
    IMAGE_UPLOADED: "image_uploaded",
    IMAGE_DELETED: "image_deleted",

    // Folder actions
    FOLDER_UPDATED: "folder_updated",

    // Package actions
    PACKAGE_CREATED: "package_created",
    PACKAGE_UPDATED: "package_updated",
    PACKAGE_DELETED: "package_deleted",

    // Package request actions
    PACKAGE_REQUEST_APPROVED: "package_request_approved",
    PACKAGE_REQUEST_REJECTED: "package_request_rejected",

    // Package booking actions
    PACKAGE_BOOKING_PAYMENT_LINK_GENERATED: "package_booking_payment_link_generated",
    PACKAGE_BOOKING_MANUAL_PAYMENT_ADDED: "package_booking_manual_payment_added",
    PACKAGE_BOOKING_PAYMENT_COMPLETED: "package_booking_payment_completed",

    // Calendar event actions
    CALENDAR_EVENT_CREATED: "calendar_event_created",
    CALENDAR_EVENT_UPDATED: "calendar_event_updated",
    CALENDAR_EVENT_DELETED: "calendar_event_deleted",
    CALENDAR_EVENT_SHARED: "calendar_event_shared",

    // Event name actions
    EVENT_NAME_CREATED: "event_name_created",
    EVENT_NAME_DELETED: "event_name_deleted",

    // User created event actions
    USER_CREATED_EVENT_DELETED: "user_created_event_deleted",

    // Customer event actions
    CUSTOMER_EVENT_SUBMITTED: "customer_event_submitted",
    CUSTOMER_PAYMENT_LINK_GENERATED: "customer_payment_link_generated",
    CUSTOMER_PAYMENT_COMPLETED: "customer_payment_completed",
    CUSTOMER_MANUAL_PAYMENT_ADDED: "customer_manual_payment_added",

    // Subscription actions
    SUBSCRIPTION_PAYMENT_STARTED: "subscription_payment_started",
    SUBSCRIPTION_PAYMENT_COMPLETED: "subscription_payment_completed",
    SUBSCRIPTION_PAYMENT_FAILED: "subscription_payment_failed",
    SUBSCRIPTION_PLANS_VIEWED: "subscription_plans_viewed",

    // Errors
    API_ERROR: "api_error",
    VALIDATION_ERROR: "validation_error",
} as const;

export type ClarityEventType = keyof typeof CLARITY_EVENTS;
